export default class DropzoneLoader {

    /**
     * 0 - not loaded
     * 1 - loading
     * 2 - loaded
     * @private
     */
    private static status = 0;

    private static promise: Promise<Dropzone>;

    private static instance: Dropzone;

    public static load(): Promise<Dropzone>{
        if(DropzoneLoader.status == 0) {
            DropzoneLoader.status = 1;
            DropzoneLoader.promise = (import(/* webpackChunkName: "dropzone" */ 'dropzone'))
                .then(dm => {
                    let dz_:Dropzone = (dm as any).default as Dropzone;
                    (dz_ as any).autoDiscover = false;
                    DropzoneLoader.instance = dz_;
                    DropzoneLoader.status = 2;
                    return dz_;
                });
            return DropzoneLoader.promise;
        }else if(DropzoneLoader.status == 1){
            return DropzoneLoader.promise;
        }else {
            return Promise.resolve(DropzoneLoader.instance);
        }
    }

}